import { font } from '@chegg-ui/theme'
import styled from 'styled-components'

export const TermsAndConditionsContainer = styled.a<{ fontSize: string; color: string }>`
  font-size: ${({ fontSize }) =>
    fontSize === 'px14' ? `${font.size.px14}` : `${font.size.px12}`};
  color: ${({ theme, color }) =>
    color === 'dark' ? theme.colors.dark : theme.colors.grey};
  text-align: center;
  text-decoration: none;
`



// WEBPACK FOOTER //
// ./src/components/TermsAndConditions/styles.tsx